module.exports = __webpack_public_path__ + "static/media/product_category_31.371515b2.png";